import React, { useCallback, useEffect, useState } from "react";
import { Drama, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import TheatreSetupWizard from "@/components/theatre/TheatreSetupWizard";

// Coach dashboard: "Finish Theatre setup" card until any director completes it; auto-opens once per director.
export default function TheatreSetupCard() {
  const { viewOnly } = useAuth();
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/coach/theatre-setup").then(({ data }) => { setStatus(data); return data; }).catch(() => null), []);

  useEffect(() => {
    if (viewOnly) return;
    load().then((data) => {
      if (data?.auto_open) { setOpen(true); api.post("/coach/theatre-setup/seen").catch(() => {}); }
    });
  }, [viewOnly, load]);

  if (viewOnly || !status?.theatre) return null;
  return (
    <>
      {status.show && (
        <Card className="mb-6 flex flex-wrap items-center justify-between gap-4 border-rose-200 bg-gradient-to-r from-rose-50 to-white p-5 shadow-sm animate-fade-in-up" data-testid="theatre-setup-card">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-rose-100 text-rose-600"><Drama className="h-5 w-5" /></span>
            <div>
              <p className="font-semibold text-slate-900">Finish Theatre setup</p>
              <p className="text-sm text-slate-500">Add your stage managers and choose your program features.</p>
            </div>
          </div>
          <Button className="rounded-full bg-slate-900 hover:bg-slate-800" onClick={() => setOpen(true)} data-testid="theatre-setup-open-btn">
            Continue setup <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </Card>
      )}
      <TheatreSetupWizard open={open} onOpenChange={setOpen} status={status} onChanged={load} />
    </>
  );
}
